import { supabase } from '@/core/database/supabase';
import type { ProgressStats } from '../types/construction-progress.types';

export const ConstructionProgressStatsService = {
  async getProgressStats(companyId: string, projectId?: string): Promise<ProgressStats> {
    let query = supabase.from('progress_logs').select('status_code, completed_quantity, progress_percent').eq('company_id', companyId);
    if (projectId) query = query.eq('project_id', projectId);

    const { data, error } = await query;
    if (error) throw error;

    const approved = data.filter(l => l.status_code === 'approved');
    const pending = data.filter(l => l.status_code === 'submitted' || l.status_code === 'reviewing').length;
    
    const totalQty = approved.reduce((sum, l) => sum + (l.completed_quantity || 0), 0);
    const avgProgress = data.length > 0 ? data.reduce((sum, l) => sum + (l.progress_percent || 0), 0) / data.length : 0;

    return {
      totalLogs: data.length,
      approvedQuantity: totalQty,
      pendingReviewCount: pending,
      completionRate: avgProgress,
    };
  }
};
